// src/hooks/useNavigation.ts
import { useNavigate } from "@tanstack/react-router";
import { useClerk } from "@clerk/tanstack-react-start";

export interface NavigationHook {
  handleLogoClick: () => void;
  handleLoginClick: (e?: React.MouseEvent) => void;
  handleRegisterClick: (e?: React.MouseEvent) => void;
}

export function useNavigation(): NavigationHook {
  const navigate = useNavigate();
  const clerk = useClerk();

  const handleLogoClick = () => {
    navigate({ to: "/" });
  };

  const handleLoginClick = (e?: React.MouseEvent) => {
    e?.preventDefault();
    clerk.openSignIn();
  };

  const handleRegisterClick = (e?: React.MouseEvent) => {
    e?.preventDefault();
    clerk.openSignUp();
  };

  return {
    handleLogoClick,
    handleLoginClick,
    handleRegisterClick,
  };
}
